import React, { useMemo } from 'react';
import { Wrapper, WrapperProps } from '../Wrapper/Wrapper';
import { Space } from '../../../theme/styledProps';

export interface Props extends WrapperProps {
  /**
   * If `true`, the borderRadius of buttons that are direct children will be altered
   * to look flushed together
   */
  isAttached?: boolean;
  /**
   * The spacing between the buttons
   */
  spacing?: Space | number;

  /**
   * For a vertical layout
   */
  isVertical?: boolean;
}

export const ButtonGroup = ({
  isAttached = false,
  spacing = '8',
  children,
  isVertical = false,
  ...rest
}: Props) => {
  const styles = useMemo(() => {
    if (isVertical) {
      return `
        display: flex;
        flex-direction: column;
        grid-gap: ${spacing}px;
      `;
    }

    if (isAttached) {
      return `
        display: inline-flex;

        > *:first-of-type:not(:last-of-type) {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        > *:not(:first-of-type):not(:last-of-type) {
          border-radius: 0;
          margin-left: -1px;
        }

        > *:not(:first-of-type):last-of-type {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          margin-left: -1px;
        }
      `;
    }

    return `
      display: inline-flex;

      & > *:not(style) ~ *:not(style) {
        margin-left: ${spacing}px;
      }
    `;
  }, [isAttached, spacing]);

  return (
    <Wrapper css={styles} {...rest}>
      {children}
    </Wrapper>
  );
};
